/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MenuOrderItemBase
 */
export interface MenuOrderItemBase {
    /**
     * 
     * @type {string}
     * @memberof MenuOrderItemBase
     */
    externalId?: string;
    /**
     * 
     * @type {string}
     * @memberof MenuOrderItemBase
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof MenuOrderItemBase
     */
    price: number;
    /**
     * 
     * @type {number}
     * @memberof MenuOrderItemBase
     */
    quantity: number;
    /**
     * 
     * @type {number}
     * @memberof MenuOrderItemBase
     */
    taxRate: number;
    /**
     * 
     * @type {string}
     * @memberof MenuOrderItemBase
     */
    notes?: string;
}

export function MenuOrderItemBaseFromJSON(json: any): MenuOrderItemBase {
    return MenuOrderItemBaseFromJSONTyped(json, false);
}

export function MenuOrderItemBaseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MenuOrderItemBase {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'externalId': !exists(json, 'externalId') ? undefined : json['externalId'],
        'name': json['name'],
        'price': json['price'],
        'quantity': json['quantity'],
        'taxRate': json['taxRate'],
        'notes': !exists(json, 'notes') ? undefined : json['notes'],
    };
}

export function MenuOrderItemBaseToJSON(value?: MenuOrderItemBase | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'externalId': value.externalId,
        'name': value.name,
        'price': value.price,
        'quantity': value.quantity,
        'taxRate': value.taxRate,
        'notes': value.notes,
    };
}


